export default __webpack_public_path__ + "static/media/ion_man-outline.51a272a4.svg";